import React from 'react'
import { Paper, Stack, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Tooltip } from '@mui/material'
import moment from 'moment/moment'
import { distributeValues, getPaymentTypeBackground, getPaymentTypeBackgrounds, getStaOptHamaliGstLabel, isStaCompany } from '../../../common/helper'
import { coloumnDispatchDetailsForExcel } from '../common/reportConstants'

const DispatchMiddSection1 = ({
  tableData,
  loginData,
  reportType,
  showSummaryReport,
  detailedFilter,
  selFromBranch,
  selDestCity,
  selBranch,
  paymentWiseTotal,
  toDate,
  fromDate,
  selVehicle,
  selPaymentTpe,
  columns,
  selectedFields,
}) => {
  const colSpanValues = distributeValues(Object.keys(selectedFields).length + 1, 3)
  const dispatchExcelColumns = coloumnDispatchDetailsForExcel(loginData?.intCompanyID)
  const operatorHamaliHeader = isStaCompany(loginData?.intCompanyID)
    ? 'ToPay Chrg.'
    : 'Operator Hamali'
  const hamOpGstHeader = isStaCompany(loginData?.intCompanyID)
    ? getStaOptHamaliGstLabel(false)
    : 'Hamali + Op.Hamali GST'
  const InsideRowContentSummary = ({ item, index, itSelfArray ,fontVal}) => {
    return (
      <>
        <TableRow>
          <TableCell colSpan={1} style={{ backgroundColor: itSelfArray.length - 1 == index ? '#EEE' : '' }}>
            <span
              style={{
                width: '150px',
                display: 'flex',
                alignItems: 'center',
                gap: '10px',
                whiteSpace: 'nowrap',
                padding: '4px 10px',
                fontWeight: 'bold',
                background: 'F5FAFE',
                fontSize: fontVal,
                fontWeight: '500',
                color: 'black',
                borderRadius: '13px',
                textAlign: 'left',
                backgroundColor: getPaymentTypeBackground(item.PaymentType),
              }}
            >
              {item.PaymentType}
            </span>
          </TableCell>
          <TableCell
            colSpan={1}
            style={{
              fontWeight: 'bold',
              background: 'F5FAFE',
              fontSize: fontVal,
              fontWeight: '500',
              textAlign: 'right',
              backgroundColor: itSelfArray.length - 1 == index ? '#EEE' : '',
            }}
          >
            {item.Quantity}
          </TableCell>
          <TableCell
            colSpan={1}
            style={{
              fontWeight: 'bold',
              background: 'F5FAFE',
              fontSize: fontVal,
              fontWeight: '500',
              textAlign: 'right',
              backgroundColor: itSelfArray.length - 1 == index ? '#EEE' : '',
            }}
          >
            {Number(item.Freight).toFixed(2)}
          </TableCell>
          <TableCell
            colSpan={1}
            style={{
              fontWeight: 'bold',
              background: 'F5FAFE',
              fontSize: fontVal,
              fontWeight: '500',
              textAlign: 'right',
              backgroundColor: itSelfArray.length - 1 == index ? '#EEE' : '',
            }}
          >
            {Number(item.DocumentCharges).toFixed(2)}
          </TableCell>
          <TableCell
            colSpan={1}
            style={{
              fontWeight: 'bold',
              background: 'F5FAFE',
              fontSize: fontVal,
              fontWeight: '500',
              textAlign: 'right',
              backgroundColor: itSelfArray.length - 1 == index ? '#EEE' : '',
            }}
          >
            {Number(item.CartageAmount).toFixed(2)}
          </TableCell>
          <TableCell
            colSpan={1}
            style={{
              fontWeight: 'bold',
              background: 'F5FAFE',
              fontSize: fontVal,
              fontWeight: '500',
              textAlign: 'right',
              backgroundColor: itSelfArray.length - 1 == index ? '#EEE' : '',
            }}
          >
            {Number(item.HamaliCharges).toFixed(2)}
          </TableCell>
          <TableCell
            colSpan={1}
            style={{
              fontWeight: 'bold',
              background: 'F5FAFE',
              fontSize: fontVal,
              fontWeight: '500',
              textAlign: 'right',
              backgroundColor: itSelfArray.length - 1 == index ? '#EEE' : '',
            }}
          >
            {Number(item.OperatorHamaliChg).toFixed(2)}
          </TableCell>
          <TableCell
            colSpan={1}
            style={{
              fontWeight: 'bold',
              background: 'F5FAFE',
              fontSize: fontVal,
              fontWeight: '500',
              textAlign: 'right',
              backgroundColor: itSelfArray.length - 1 == index ? '#EEE' : '',
            }}
          >
            {Number(item.ServiceTaxAmount).toFixed(2)}
          </TableCell>
          <TableCell
            colSpan={1}
            style={{
              fontWeight: 'bold',
              background: 'F5FAFE',
              fontSize: fontVal,
              fontWeight: '500',
              textAlign: 'right',
              backgroundColor: itSelfArray.length - 1 == index ? '#EEE' : '',
            }}
          >
            {Number(item.CartageTax).toFixed(2)}
          </TableCell>
          <TableCell
            colSpan={1}
            style={{
              fontWeight: 'bold',
              background: 'F5FAFE',
              fontSize: fontVal,
              fontWeight: '500',
              textAlign: 'right',
              backgroundColor: itSelfArray.length - 1 == index ? '#EEE' : '',
            }}
          >
            {Number(item.OptHamaliGST).toFixed(2)}
          </TableCell>
          <TableCell
            colSpan={1}
            style={{
              fontWeight: 'bold',
              background: 'F5FAFE',
              fontSize: fontVal,
              fontWeight: '500',
              textAlign: 'right',
              backgroundColor: itSelfArray.length - 1 == index ? '#EEE' : '',
            }}
          >
            {Number(item.Insurance).toFixed(2)}
          </TableCell>
          <TableCell
            colSpan={1}
            style={{
              fontWeight: 'bold',
              background: 'F5FAFE',
              fontSize: fontVal,
              fontWeight: '500',
              textAlign: 'right',
              backgroundColor: itSelfArray.length - 1 == index ? '#EEE' : '',
            }}
          >
            {Number(item.NetAmount).toFixed(2)}
          </TableCell>
        </TableRow>
      </>
    )
  }
  const InsideRowContent = ({ item, index, selectedFields,fontVal }) => {
    return (
      <>
        {
          <TableRow style={{ whiteSpace: 'nowrap' }}>
            {Object.keys(item).length == 13 ? (
              <>
                <TableCell
                  className="receivedTD"
                  style={{
                    fontWeight: 'bold',
                    background: '#f1f9ff',
                    fontSize: fontVal,
                    fontWeight: '500',
                    textAlign: 'left',
                    borderbottom: '1px solid rgba(0, 0, 0, 0.10)',
                    whiteSpace: 'pre-wrap',
                    height: '36px',
                  }}
                  colSpan={22}
                >
                  {`${item.SN} , ${item.DispatchDateTime} `}
                </TableCell>
              </>
            ) : Object.keys(item).length == 22 ? (
              <>
                <TableCell
                  className="reportTD"
                  // colSpan={11}
                  colSpan={Object.keys(selectedFields).indexOf('PaymentType') ? Object.keys(selectedFields).indexOf('PaymentType') + 1 : 10}
                  style={{
                    fontWeight: 'bold',
                    backgroundColor: '#EEE',
                    color: '#444444',
                    fontSize: fontVal,
                    fontWeight: '700',
                    textAlign: 'right',
                    whiteSpace: 'nowrap',
                    borderbottom: '1px solid rgba(0, 0, 0, 0.10)',
                  }}
                >
                  {item.PaymentType}
                </TableCell>
                {selectedFields.hasOwnProperty('Quantity') && (
                  <TableCell
                    className="reportTD"
                    colSpan={1}
                    style={{
                      fontWeight: 'bold',
                      backgroundColor: '#EEE',
                      fontSize: fontVal,
                      fontWeight: '700',
                      textAlign: 'right',
                      whiteSpace: 'nowrap',
                    }}
                  >
                    {item.Quantity}
                  </TableCell>
                )}

                {selectedFields.hasOwnProperty('Freight') && (
                  <TableCell
                    className="reportTD"
                    colSpan={1}
                    style={{
                      fontWeight: 'bold',
                      backgroundColor: '#EEE',
                      fontSize: fontVal,
                      fontWeight: '700',
                      textAlign: 'right',
                      whiteSpace: 'nowrap',
                    }}
                  >
                    {Number(item.Freight).toFixed(2)}
                  </TableCell>
                )}
                {selectedFields.hasOwnProperty('DocumentCharges') && (
                  <TableCell
                    className="reportTD"
                    colSpan={1}
                    style={{
                      fontWeight: 'bold',
                      backgroundColor: '#EEE',
                      fontSize: fontVal,
                      fontWeight: '700',
                      textAlign: 'right',
                      whiteSpace: 'nowrap',
                    }}
                  >
                    {Number(item.DocumentCharges).toFixed(2)}
                  </TableCell>
                )}
                {selectedFields.hasOwnProperty('CartageAmount') && (
                  <TableCell
                    className="reportTD"
                    colSpan={1}
                    style={{
                      fontWeight: 'bold',
                      backgroundColor: '#EEE',
                      fontSize: fontVal,
                      fontWeight: '700',
                      textAlign: 'right',
                      whiteSpace: 'nowrap',
                    }}
                  >
                    {Number(item.CartageAmount).toFixed(2)}
                  </TableCell>
                )}
                {selectedFields.hasOwnProperty('HamaliCharges') && (
                  <TableCell
                    className="reportTD"
                    colSpan={1}
                    style={{
                      fontWeight: 'bold',
                      backgroundColor: '#EEE',
                      fontSize: fontVal,
                      fontWeight: '700',
                      textAlign: 'right',
                      whiteSpace: 'nowrap',
                    }}
                  >
                    {Number(item.HamaliCharges).toFixed(2)}
                  </TableCell>
                )}
                {selectedFields.hasOwnProperty('OperatorHamaliChg') && (
                  <TableCell
                    className="reportTD"
                    colSpan={1}
                    style={{
                      fontWeight: 'bold',
                      backgroundColor: '#EEE',
                      fontSize: fontVal,
                      fontWeight: '700',
                      textAlign: 'right',
                      whiteSpace: 'nowrap',
                    }}
                  >
                    {Number(item.OperatorHamaliChg).toFixed(2)}
                  </TableCell>
                )}
                {selectedFields.hasOwnProperty('ServiceTaxAmount') && (
                  <TableCell
                    className="reportTD"
                    colSpan={1}
                    style={{
                      fontWeight: 'bold',
                      backgroundColor: '#EEE',
                      fontSize: fontVal,
                      fontWeight: '700',
                      textAlign: 'right',
                      whiteSpace: 'nowrap',
                    }}
                  >
                    {Number(item.ServiceTaxAmount).toFixed(2)}
                  </TableCell>
                )}
                {selectedFields.hasOwnProperty('CartageTax') && (
                  <TableCell
                    className="reportTD"
                    colSpan={1}
                    style={{
                      fontWeight: 'bold',
                      backgroundColor: '#EEE',
                      fontSize: fontVal,
                      fontWeight: '700',
                      textAlign: 'right',
                      whiteSpace: 'nowrap',
                    }}
                  >
                    {Number(item.CartageTax).toFixed(2)}
                  </TableCell>
                )}
                {selectedFields.hasOwnProperty('OptHamaliGST') && (
                  <TableCell
                    className="reportTD"
                    colSpan={1}
                    style={{
                      fontWeight: 'bold',
                      backgroundColor: '#EEE',
                      fontSize: fontVal,
                      fontWeight: '700',
                      textAlign: 'right',
                      whiteSpace: 'nowrap',
                    }}
                  >
                    {Number(item.OptHamaliGST).toFixed(2)}
                  </TableCell>
                )}
                {selectedFields.hasOwnProperty('Insurance') && (
                  <TableCell
                    className="reportTD"
                    colSpan={1}
                    style={{
                      fontWeight: 'bold',
                      backgroundColor: '#EEE',
                      fontSize: fontVal,
                      fontWeight: '700',
                      textAlign: 'right',
                      whiteSpace: 'nowrap',
                    }}
                  >
                    {Number(item.Insurance).toFixed(2)}
                  </TableCell>
                )}
                {selectedFields.hasOwnProperty('NetAmount') && (
                  <TableCell
                    className="reportTD"
                    colSpan={1}
                    style={{
                      fontWeight: 'bold',
                      backgroundColor: '#EEE',
                      fontSize: fontVal,
                      fontWeight: '700',
                      textAlign: 'right',
                      whiteSpace: 'nowrap',
                    }}
                  >
                    {Number(item.NetAmount).toFixed(2)}
                  </TableCell>
                )}
              </>
            ) : (
              <>
                <TableCell
                  className="reportTD"
                  colSpan={1}
                  style={{ verticalAlign:'top', fontSize: fontVal, fontWeight: '500', textAlign: 'left' }}
                >
                  {item.SN}
                </TableCell>
                {selectedFields.hasOwnProperty('pdfLRNO') && (
                  <TableCell
                    className="reportTD"
                    colSpan={1}
                    style={{
                      verticalAlign:'top',
                      fontSize: fontVal,
                      fontWeight: '500',
                      textAlign: 'left',
                      whiteSpace: 'pre',
                    }}
                  >
                    {item.pdfLRNO}&nbsp;
                  </TableCell>
                )}
                {/* <TableCell
                  className="reportTD"
                  colSpan={1}
                  style={{
                    verticalAlign:'top',
                    fontSize: fontVal,
                    fontWeight: '500',
                    textAlign: 'left',
                    whiteSpace: 'pre',
                  }}
                >
                  {item.pdfVoucherNo}
                </TableCell> */}
                {selectedFields.hasOwnProperty('pdfVoucherNo') && (
                  <TableCell
                    className="reportTD"
                    colSpan={1}
                    style={{
                      verticalAlign:'top',
                      fontSize: fontVal,
                      fontWeight: '500',
                      textAlign: 'left',
                      whiteSpace: 'pre',
                    }}
                  >
                      {item.pdfVoucherNo}
                  </TableCell>
                )}
                <TableCell
                  className="reportTD"
                  colSpan={1}
                  style={{
                    verticalAlign:'top',
                    fontSize: fontVal,
                    fontWeight: '500',
                    textAlign: 'left',
                    whiteSpace: 'pre',
                  }}
                >
                  {item.DispDT}
                </TableCell>
                <TableCell
                  className="reportTD"
                  colSpan={1}
                  style={{
                    verticalAlign:'top',
                    fontSize: fontVal,
                    fontWeight: '500',
                    textAlign: 'left',
                    whiteSpace: 'pre',
                  }}
                >
                  {item.SrcDestCity}
                </TableCell>
                {/* <TableCell
                  className="reportTD"
                  colSpan={1}
                  style={{
                    verticalAlign:'top',
                    fontSize: fontVal,
                    fontWeight: '500',
                    textAlign: 'left',
                    whiteSpace: 'pre',
                    overflow: 'hidden',
                    textOverflow: 'ellipsis',
                    maxWidth: '150px',
                  }}
                >
                  <Tooltip title={item.DestCityBranch} placement="top-start">
                    <span>{item.DestCityBranch}</span>
                  </Tooltip>
                </TableCell> */}
                    {selectedFields.hasOwnProperty('DestCityBranch') && (
                      <TableCell
                        className="reportTD"
                        colSpan={1}
                        style={{
                          verticalAlign: 'top',
                          fontSize: fontVal,
                          fontWeight: '500',
                          textAlign: 'left',
                          whiteSpace: 'pre',
                          overflow: 'hidden',
                          textOverflow: 'ellipsis',
                          maxWidth: '150px',
                        }}
                      >
                        <Tooltip title={item.DestCityBranch} placement="top-start">
                          <span>{item.DestCityBranch}</span>
                        </Tooltip>
                      </TableCell>
                    )}
                {selectedFields.hasOwnProperty('PickupCityBrnach') && (
                  <TableCell
                    className="reportTD"
                    colSpan={1}
                    style={{ verticalAlign:'top', fontSize: fontVal, fontWeight: '500', textAlign: 'left' }}
                  >
                    {item.PickupCityBrnach}
                  </TableCell>
                )}
                {selectedFields.hasOwnProperty('senderDetailes') && (
                  <TableCell
                    className="reportTD"
                    colSpan={1}
                    style={{
                      verticalAlign:'top',
                      fontSize: fontVal,
                      fontWeight: '500',
                      textAlign: 'left',
                      whiteSpace: 'pre',
                      overflow: 'hidden',
                      textOverflow: 'ellipsis',
                      maxWidth: '150px',
                    }}
                  >
                    <Tooltip title={item.senderDetailes} placement="top-start">
                      <span>{item.senderDetailes}</span>
                    </Tooltip>
                  </TableCell>
                )}
                {selectedFields.hasOwnProperty('recDetails') && (
                  <TableCell
                    className="reportTD"
                    colSpan={1}
                    style={{
                      verticalAlign:'top',
                      fontSize: fontVal,
                      fontWeight: '500',
                      whiteSpace: 'pre',
                      textAlign: 'left',
                      overflow: 'hidden',
                      textOverflow: 'ellipsis',
                      maxWidth: '150px',
                    }}
                  >
                    <Tooltip title={item.recDetails} placement="top-start">
                      <span>{item.recDetails}</span>
                    </Tooltip>
                  </TableCell>
                )}
                {selectedFields.hasOwnProperty('ItemDetails') && (
                  <TableCell
                    className="reportTD"
                    colSpan={1}
                    style={{
                      verticalAlign:'top',
                      fontSize: fontVal,
                      fontWeight: '500',
                      textAlign: 'left',
                      whiteSpace: 'nowrap',
                      textAlign: 'left',
                      overflow: 'hidden',
                      textOverflow: 'ellipsis',
                      maxWidth: '150px',
                    }}
                  >
                    <Tooltip title={item.ItemDetails} placement="top-start">
                      <span>{item.ItemDetails}</span>
                    </Tooltip>
                  </TableCell>
                )}
                {selectedFields.hasOwnProperty('PaymentType') && (
                  <TableCell className="reportTD" colSpan={1}>
                    <span
                      style={{
                        width: '150px',
                        display: 'flex',
                        padding: ' 4px 10px',
                        alignItems: 'center',
                        gap: '10px',
                        whiteSpace: 'nowrap',
                        padding: '4px 10px',
                        verticalAlign:'top',
                        fontSize: fontVal,
                        fontWeight: '500',
                        color: 'black',
                        borderRadius: '13px',
                        textAlign: 'left',
                        backgroundColor: getPaymentTypeBackground(item.PaymentType), //getPaymentTypeBackground
                      }}
                    >
                      {item.PaymentType}
                    </span>
                  </TableCell>
                )}
                {selectedFields.hasOwnProperty('PaymentType') && (
                  <TableCell
                    className="reportTD"
                    colSpan={1}
                    style={{ verticalAlign:'top', fontSize: fontVal, fontWeight: '500', textAlign: 'right' }}
                  >
                    {item.Quantity}
                  </TableCell>
                )}
                {selectedFields.hasOwnProperty('Freight') && (
                  <TableCell
                    className="reportTD"
                    colSpan={1}
                    style={{ verticalAlign:'top', fontSize: fontVal, fontWeight: '500', textAlign: 'right' }}
                  >
                    {Number(item.Freight).toFixed(2)}
                  </TableCell>
                )}
                {selectedFields.hasOwnProperty('DocumentCharges') && (
                  <TableCell
                    className="reportTD"
                    colSpan={1}
                    style={{ verticalAlign:'top', fontSize: fontVal, fontWeight: '500', textAlign: 'right' }}
                  >
                    {Number(item.DocumentCharges).toFixed(2)}
                  </TableCell>
                )}
                {selectedFields.hasOwnProperty('CartageAmount') && (
                  <TableCell
                    className="reportTD"
                    colSpan={1}
                    style={{ verticalAlign:'top', fontSize: fontVal, fontWeight: '500', textAlign: 'right' }}
                  >
                    {Number(item.CartageAmount).toFixed(2)}
                  </TableCell>
                )}
                {selectedFields.hasOwnProperty('HamaliCharges') && (
                  <TableCell
                    className="reportTD"
                    colSpan={1}
                    style={{ verticalAlign:'top', fontSize: fontVal, fontWeight: '500', textAlign: 'right' }}
                  >
                    {Number(item.HamaliCharges).toFixed(2)}
                  </TableCell>
                )}
                {selectedFields.hasOwnProperty('OperatorHamaliChg') && (
                  <TableCell
                    className="reportTD"
                    colSpan={1}
                    style={{ verticalAlign:'top', fontSize: fontVal, fontWeight: '500', textAlign: 'right' }}
                  >
                    {Number(item.OperatorHamaliChg).toFixed(2)}
                  </TableCell>
                )}
                {selectedFields.hasOwnProperty('ServiceTaxAmount') && (
                  <TableCell
                    className="reportTD"
                    colSpan={1}
                    style={{ verticalAlign:'top', fontSize: fontVal, fontWeight: '500', textAlign: 'right' }}
                  >
                    {Number(item.ServiceTaxAmount).toFixed(2)}
                  </TableCell>
                )}
                {selectedFields.hasOwnProperty('CartageTax') && (
                  <TableCell
                    className="reportTD"
                    colSpan={1}
                    style={{ verticalAlign:'top', fontSize: fontVal, fontWeight: '500', textAlign: 'right' }}
                  >
                    {Number(item.CartageTax).toFixed(2)}
                  </TableCell>
                )}
                {selectedFields.hasOwnProperty('OptHamaliGST') && (
                  <TableCell
                    className="reportTD"
                    colSpan={1}
                    style={{ verticalAlign:'top', fontSize: fontVal, fontWeight: '500', textAlign: 'right' }}
                  >
                    {Number(item.OptHamaliGST).toFixed(2)}
                  </TableCell>
                )}
                {selectedFields.hasOwnProperty('Insurance') && (
                  <TableCell
                    className="reportTD"
                    colSpan={1}
                    style={{ verticalAlign:'top', fontSize: fontVal, fontWeight: '500', textAlign: 'right' }}
                  >
                    {Number(item.Insurance).toFixed(2)}
                  </TableCell>
                )}
                {selectedFields.hasOwnProperty('NetAmount') && (
                  <TableCell
                    className="reportTD"
                    colSpan={1}
                    style={{ verticalAlign:'top', fontSize: fontVal, fontWeight: '500', textAlign: 'right' }}
                  >
                    {Number(item.NetAmount).toFixed(2)}
                  </TableCell>
                )}
                {selectedFields.hasOwnProperty('CancelledByUser') && (
                  <TableCell
                    className="reportTD"
                    colSpan={1}
                    style={{ verticalAlign:'top', fontSize: fontVal, fontWeight: '500', textAlign: 'right' }}
                  >
                    {item.CancelledByUser}
                  </TableCell>
                )}
                {selectedFields.hasOwnProperty('CancelledDate') && (
                  <TableCell
                    className="reportTD"
                    colSpan={1}
                    style={{ verticalAlign:'top', fontSize: fontVal, fontWeight: '500', textAlign: 'right' }}
                  >
                    {item.CancelledDate}
                  </TableCell>
                )}
              </>
            )}
          </TableRow>
        }
      </>
    )
  }
  const InsideRowContentForExcel = ({ item,fontVal }) => {
    return (
      <>
        {
          <TableRow >
            {Object.keys(item).length == 13 ? (
              <>
                <TableCell
                  className="receivedTD"
                  style={{
                    fontWeight: 'bold',
                    background: '#f1f9ff',
                    fontSize: fontVal,
                    fontWeight: '500',
                    textAlign: 'left',
                    borderbottom: '1px solid rgba(0, 0, 0, 0.10)',
                    whiteSpace: 'pre-wrap',
                    height: '36px',
                  }}
                  colSpan={34}
                >
                  {`${item.SN} , ${item.DispatchDateTime} `}
                </TableCell>
              </>
            ) : Object.keys(item).length == 22 ? (
              <>
                <TableCell
                  className="reportTD"
                  // colSpan={Object.keys(selectedFields).indexOf('PaymentType') ? Object.keys(selectedFields).indexOf('PaymentType') + 2 : 10}
                  colSpan={23}
                  style={{
                    backgroundColor: '#EEE',
                    fontSize: fontVal,
                    fontWeight: '700',
                    textAlign: 'right',
                    whiteSpace: 'nowrap',
                    borderbottom: '1px solid rgba(0, 0, 0, 0.10)',
                  }}
                >
                  {item.PaymentType}
                </TableCell>
                
                  <TableCell
                    className="reportTD"
                    colSpan={1}
                    style={{
                      fontWeight: 'bold',
                      backgroundColor: '#EEE',
                      fontSize: fontVal,
                      fontWeight: '700',
                      textAlign: 'right',
                      whiteSpace: 'nowrap',
                    }}
                  >
                    {item.Quantity}
                  </TableCell>
                  <TableCell
                    className="reportTD"
                    colSpan={1}
                    style={{
                      fontWeight: 'bold',
                      backgroundColor: '#EEE',
                      fontSize: fontVal,
                      fontWeight: '700',
                      textAlign: 'right',
                      whiteSpace: 'nowrap',
                    }}
                  >
                    {Number(item.Freight).toFixed(2)}
                  </TableCell>
                  <TableCell
                    className="reportTD"
                    colSpan={1}
                    style={{
                      fontWeight: 'bold',
                      backgroundColor: '#EEE',
                      fontSize: fontVal,
                      fontWeight: '700',
                      textAlign: 'right',
                      whiteSpace: 'nowrap',
                    }}
                  >
                    {Number(item.DocumentCharges).toFixed(2)}
                  </TableCell>
                  <TableCell
                    className="reportTD"
                    colSpan={1}
                    style={{
                      fontWeight: 'bold',
                      backgroundColor: '#EEE',
                      fontSize: fontVal,
                      fontWeight: '700',
                      textAlign: 'right',
                      whiteSpace: 'nowrap',
                    }}
                  >
                    {Number(item.CartageAmount).toFixed(2)}
                  </TableCell>
                  <TableCell
                    className="reportTD"
                    colSpan={1}
                    style={{
                      fontWeight: 'bold',
                      backgroundColor: '#EEE',
                      fontSize: fontVal,
                      fontWeight: '700',
                      textAlign: 'right',
                      whiteSpace: 'nowrap',
                    }}
                  >
                    {Number(item.HamaliCharges).toFixed(2)}
                  </TableCell>
                  <TableCell
                    className="reportTD"
                    colSpan={1}
                    style={{
                      fontWeight: 'bold',
                      backgroundColor: '#EEE',
                      fontSize: fontVal,
                      fontWeight: '700',
                      textAlign: 'right',
                      whiteSpace: 'nowrap',
                    }}
                  >
                    {Number(item.OperatorHamaliChg).toFixed(2)}
                  </TableCell>
                  <TableCell
                    className="reportTD"
                    colSpan={1}
                    style={{
                      fontWeight: 'bold',
                      backgroundColor: '#EEE',
                      fontSize: fontVal,
                      fontWeight: '700',
                      textAlign: 'right',
                      whiteSpace: 'nowrap',
                    }}
                  >
                    {Number(item.ServiceTaxAmount).toFixed(2)}
                  </TableCell>
                  <TableCell
                    className="reportTD"
                    colSpan={1}
                    style={{
                      fontWeight: 'bold',
                      backgroundColor: '#EEE',
                      fontSize: fontVal,
                      fontWeight: '700',
                      textAlign: 'right',
                      whiteSpace: 'nowrap',
                    }}
                  >
                    {Number(item.CartageTax).toFixed(2)}
                  </TableCell>
                  <TableCell
                    className="reportTD"
                    colSpan={1}
                    style={{
                      fontWeight: 'bold',
                      backgroundColor: '#EEE',
                      fontSize: fontVal,
                      fontWeight: '700',
                      textAlign: 'right',
                      whiteSpace: 'nowrap',
                    }}
                  >
                    {Number(item.OptHamaliGST).toFixed(2)}
                  </TableCell>
                  <TableCell
                    className="reportTD"
                    colSpan={1}
                    style={{
                      fontWeight: 'bold',
                      backgroundColor: '#EEE',
                      fontSize: fontVal,
                      fontWeight: '700',
                      textAlign: 'right',
                      whiteSpace: 'nowrap',
                    }}
                  >
                    {Number(item.Insurance).toFixed(2)}
                  </TableCell>
                  <TableCell
                    className="reportTD"
                    colSpan={1}
                    style={{
                      fontWeight: 'bold',
                      backgroundColor: '#EEE',
                      fontSize: fontVal,
                      fontWeight: '700',
                      textAlign: 'right',
                      whiteSpace: 'nowrap',
                    }}
                  >
                    {Number(item.NetAmount).toFixed(2)}
                  </TableCell>
              </>
            ) : (
              <>
                <TableCell
                  className="reportTD"
                  colSpan={1}
                  style={{ verticalAlign:'top' , fontSize: fontVal, fontWeight: '500', textAlign: 'left' }}
                >
                  {item.SN}
                </TableCell>
                  <TableCell
                    className="reportTD"
                    colSpan={1}
                    style={{
                      verticalAlign:'top' ,
                      fontSize: fontVal,
                      fontWeight: '500',
                      textAlign: 'left',
                      whiteSpace:'pre-line',
                    }}
                  >
                    {item.OnlyLRNo}&nbsp;
                  </TableCell>
                  <TableCell
                    className="reportTD"
                    colSpan={1}
                    style={{
                    
                      verticalAlign:'top' ,
                      fontSize: fontVal,
                      fontWeight: '500',
                      textAlign: 'left',
                      whiteSpace:'pre-line',
                    }}
                  >
                    {item.ManualLR}&nbsp;
                  </TableCell>
                <TableCell
                  className="reportTD"
                  colSpan={1}
                  style={{
                  
                    verticalAlign:'top' ,
                    fontSize: fontVal,
                    fontWeight: '500',
                    textAlign: 'left',
                    whiteSpace:'pre-line',
                  }}
                >
                  {item.VoucherNo}
                </TableCell>
                <TableCell
                  className="reportTD"
                  colSpan={1}
                  style={{
                  
                    verticalAlign:'top' ,
                    fontSize: fontVal,
                    fontWeight: '500',
                    textAlign: 'left',
                    whiteSpace:'pre-line',
                  }}
                >
                  {item.PartyBillNo}
                </TableCell>
                <TableCell
                  className="reportTD"
                  colSpan={1}
                  style={{
                  
                    verticalAlign:'top' ,
                    fontSize: fontVal,
                    fontWeight: '500',
                    textAlign: 'left',
                    whiteSpace:'nowrap',
                  }}
                >
                 {moment(new Date(item.DispDT)).format('DD-MMM-YY')}
                </TableCell>
                <TableCell
                  className="reportTD"
                  colSpan={1}
                  style={{
                  
                    verticalAlign:'top' ,
                    fontSize: fontVal,
                    fontWeight: '500',
                    textAlign: 'left',
                    whiteSpace:'pre-line',
                  }}
                >
                  {moment(new Date(item.DispDT)).format('HH:mm'  )}
                </TableCell>
                <TableCell
                  className="reportTD"
                  colSpan={1}
                  style={{
                  
                    verticalAlign:'top' ,
                    fontSize: fontVal,
                    fontWeight: '500',
                    textAlign: 'left',
                    whiteSpace:'pre-line',
                  }}
                >
                    {item.BookCity}
                </TableCell>
                <TableCell
                  className="reportTD"
                  colSpan={1}
                  style={{
                  
                    verticalAlign:'top' ,
                    fontSize: fontVal,
                    fontWeight: '500',
                    textAlign: 'left',
                    whiteSpace:'pre-line',
                  }}
                >
                    {item.ToCity}
                </TableCell>
                <TableCell
                  className="reportTD"
                  colSpan={1}
                  style={{
                  
                    verticalAlign:'top' ,
                    fontSize: fontVal,
                    fontWeight: '500',
                    textAlign: 'left',
                    whiteSpace:'pre-line',
                  }}
                >
                    {item.DispatchedToCityFilter}
                </TableCell>
                <TableCell
                  className="reportTD"
                  colSpan={1}
                  style={{
                  
                    verticalAlign:'top' ,
                    fontSize: fontVal,
                    fontWeight: '500',
                    textAlign: 'left',
                    whiteSpace:'pre-line',
                  }}
                >
                    {item.DispatchedToBranchFilter}
                </TableCell>
                  <TableCell
                    className="reportTD"
                    colSpan={1}
                    style={{ verticalAlign:'top' , fontSize: fontVal, fontWeight: '500', textAlign: 'left' }}
                  >
                    {item.PickupCity}
                  </TableCell>
                  <TableCell
                    className="reportTD"
                    colSpan={1}
                    style={{ verticalAlign:'top' , fontSize: fontVal, fontWeight: '500', textAlign: 'left' }}
                  >
                    {item.PickupBranch}
                  </TableCell>
                  <TableCell
                    className="reportTD"
                    colSpan={1}
                    style={{
                    
                      verticalAlign:'top' ,
                      fontSize: fontVal,
                      fontWeight: '500',
                      textAlign: 'left',
                      whiteSpace:'pre-line',
                    }}
                  >
                     {item.SenderName}
                  </TableCell>
                  <TableCell
                    className="reportTD"
                    colSpan={1}
                    style={{
                    
                      verticalAlign:'top' ,
                      fontSize: fontVal,
                      fontWeight: '500',
                      textAlign: 'left',
                      whiteSpace:'pre-line',
                    }}
                  >
                      {item.SenderMobileNo}
                  </TableCell>
                  <TableCell
                    className="reportTD"
                    colSpan={1}
                    style={{
                    
                      verticalAlign:'top' ,
                      fontSize: fontVal,
                      fontWeight: '500',
                      textAlign: 'left',
                    }}
                  >
                      {item.SenderGSTN}
                  </TableCell>
                  <TableCell
                    className="reportTD"
                    colSpan={1}
                    style={{
                    
                      verticalAlign:'top' ,
                      fontSize: fontVal,
                      fontWeight: '500',
                      textAlign: 'left',
                    }}
                  >
                      {item.SenderEmailID}
                  </TableCell>
                  <TableCell
                    className="reportTD"
                    colSpan={1}
                    style={{
                    
                      verticalAlign:'top' ,
                      fontSize: fontVal,
                      fontWeight: '500',
                      whiteSpace:'pre-line',
                      textAlign: 'left',
                    }}
                  >
                    {item.RecName}
                  </TableCell>
                  <TableCell
                    className="reportTD"
                    colSpan={1}
                    style={{
                    
                      verticalAlign:'top' ,
                      fontSize: fontVal,
                      fontWeight: '500',
                      whiteSpace:'pre-line',
                      textAlign: 'left',
                    }}
                  >
                    {item.RecMobileNo}
                  </TableCell>
                  <TableCell
                    className="reportTD"
                    colSpan={1}
                    style={{
                    
                      verticalAlign:'top' ,
                      fontSize: fontVal,
                      fontWeight: '500',
                      whiteSpace:'pre-line',
                      textAlign: 'left',
                    }}
                  >
                    {item.ReceiverGSTN}
                  </TableCell>
                  <TableCell
                    className="reportTD"
                    colSpan={1}
                    style={{
                    
                      verticalAlign:'top' ,
                      fontSize: fontVal,
                      fontWeight: '500',
                      whiteSpace:'pre-line',
                      textAlign: 'left',
                    }}
                  >
                    {item.ReceiverEmailID}
                  </TableCell>
                  <TableCell
                    className="reportTD"
                    colSpan={1}
                    style={{
                    
                      verticalAlign:'top' ,
                      fontSize: fontVal,
                      fontWeight: '500',
                      textAlign: 'left',
                      whiteSpace: 'nowrap',
                      textAlign: 'left',
                    }}
                  >
                      {item.ItemDetails}
                  </TableCell>
                  <TableCell className="reportTD" colSpan={1}>
                    <span
                      style={{
                        width: '150px',
                        display: 'flex',
                        padding: ' 4px 10px',
                        alignItems: 'center',
                        gap: '10px',
                        whiteSpace: 'nowrap',
                        padding: '4px 10px',
                      
                        verticalAlign:'top' ,
                        fontSize: fontVal,
                        fontWeight: '500',
                        color: 'black',
                        borderRadius: '13px',
                        textAlign: 'left',
                        backgroundColor: getPaymentTypeBackground(item.PaymentType), //getPaymentTypeBackground
                      }}
                    >
                      {item.PaymentType}
                    </span>
                  </TableCell>
                  <TableCell
                    className="reportTD"
                    colSpan={1}
                    style={{ verticalAlign:'top' , fontSize: fontVal, fontWeight: '500', textAlign: 'right' }}
                  >
                    {item.Quantity}
                  </TableCell>
                  <TableCell
                    className="reportTD"
                    colSpan={1}
                    style={{ verticalAlign:'top' , fontSize: fontVal, fontWeight: '500', textAlign: 'right' }}
                  >
                    {Number(item.Freight).toFixed(2)}
                  </TableCell>
                  <TableCell
                    className="reportTD"
                    colSpan={1}
                    style={{ verticalAlign:'top' , fontSize: fontVal, fontWeight: '500', textAlign: 'right' }}
                  >
                    {Number(item.DocumentCharges).toFixed(2)}
                  </TableCell>
                  <TableCell
                    className="reportTD"
                    colSpan={1}
                    style={{ verticalAlign:'top' , fontSize: fontVal, fontWeight: '500', textAlign: 'right' }}
                  >
                    {Number(item.CartageAmount).toFixed(2)}
                  </TableCell>
                  <TableCell
                    className="reportTD"
                    colSpan={1}
                    style={{ verticalAlign:'top' , fontSize: fontVal, fontWeight: '500', textAlign: 'right' }}
                  >
                    {Number(item.HamaliCharges).toFixed(2)}
                  </TableCell>
                  <TableCell
                    className="reportTD"
                    colSpan={1}
                    style={{ verticalAlign:'top' , fontSize: fontVal, fontWeight: '500', textAlign: 'right' }}
                  >
                    {Number(item.OperatorHamaliChg).toFixed(2)}
                  </TableCell>
                  <TableCell
                    className="reportTD"
                    colSpan={1}
                    style={{ verticalAlign:'top' , fontSize: fontVal, fontWeight: '500', textAlign: 'right' }}
                  >
                    {Number(item.ServiceTaxAmount).toFixed(2)}
                  </TableCell>
                  <TableCell
                    className="reportTD"
                    colSpan={1}
                    style={{ verticalAlign:'top' , fontSize: fontVal, fontWeight: '500', textAlign: 'right' }}
                  >
                    {Number(item.CartageTax).toFixed(2)}
                  </TableCell>
                  <TableCell
                    className="reportTD"
                    colSpan={1}
                    style={{ verticalAlign:'top' , fontSize: fontVal, fontWeight: '500', textAlign: 'right' }}
                  >
                    {Number(item.OptHamaliGST).toFixed(2)}
                  </TableCell>
                  <TableCell
                    className="reportTD"
                    colSpan={1}
                    style={{ verticalAlign:'top' , fontSize: fontVal, fontWeight: '500', textAlign: 'right' }}
                  >
                    {Number(item.Insurance).toFixed(2)}
                  </TableCell>
                  <TableCell
                    className="reportTD"
                    colSpan={1}
                    style={{ verticalAlign:'top' , fontSize: fontVal, fontWeight: '500', textAlign: 'right' }}
                  >
                    {Number(item.NetAmount).toFixed(2)}
                  </TableCell>
                  <TableCell
                    className="reportTD"
                    colSpan={1}
                    style={{ verticalAlign:'top' , fontSize: fontVal, fontWeight: '500', textAlign: 'right' }}
                  >
                    {item.CancelledByUser}
                  </TableCell>
                  <TableCell
                    className="reportTD"
                    colSpan={1}
                    style={{ verticalAlign:'top' , fontSize: fontVal, fontWeight: '500', textAlign: 'right' }}
                  >
                    {item.CancelledDate}
                  </TableCell>
              </>
            )}
          </TableRow>
        }
      </>
    )
  }
  return (
    <>
      <Stack sx={{ marginLeft: 2, marginRight: 2, height: 480, paddingTop: '10px' }}>
        <TableContainer
          sx={{ '&::-webkit-scrollbar': { width: '6px', height: '6px',color:"#0086FF" }, border: '1px solid #aeaeae','& .MuiTableCell-root': {
            fontSize: '14px !important'
        }}}
          component={Paper}
          className="scrollBlue"
        >
          <Table>
            <Table style={{ minWidth: '100%' }} className="table1 table-Report" size="small" aria-label="a dense table">
              <TableHead style={{ fontWeight: 'bold', position: 'sticky', top: '0' }}>
                <TableRow style={{ backgroundColor: '#bfe1ff', color: '#444444' }}>
                  <TableCell
                    className="reportTD"
                    style={{ fontSize: '14px', fontWeight: '700', textAlign: 'left', color: '#444444', height: '36px' }}
                    colSpan={8}
                  >
                    {/* Dispatch By Branch: {selFromBranch?.name || loginData?.strBranchName} */}
                  </TableCell>
                  <TableCell
                    className="reportTD"
                    style={{ fontSize: '14px', fontWeight: '700', textAlign: 'center', color: '#444444' }}
                    colSpan={8}
                  >
                    Destination City: {selDestCity?.name}
                  </TableCell>
                  {reportType?.Name === 'Cancel Dispatch' ? (
                    <>
                      <TableCell
                        className="reportTD"
                        style={{ fontSize: '14px', fontWeight: '700', textAlign: 'right', color: '#444444' }}
                        colSpan={8}
                      >
                        Destination Branch: {selBranch?.name}
                      </TableCell>
                    </>
                  ) : (
                    <>
                      <TableCell
                        className="reportTD"
                        style={{ fontWeight: 'bold', fontSize: '14px', fontWeight: '700', textAlign: 'right', color: '#444444' }}
                        colSpan={6}
                      >
                        Destination Branch: {selBranch?.name}
                      </TableCell>
                    </>
                  )}
                </TableRow>
                <TableRow>
                  {columns
                    .filter((item) => item.isSelected)
                    .map((item, index) => (
                      <TableCell
                        className="ReportItemHead"
                        style={{
                          backgroundColor: '#e5f3ff',
                          color: '#454646',
                          fontSize: '12px',
                          fontWeight: '500',
                          // textAlign: index < 11 ? 'left' : 'right',
                          textAlign: item.xlCol.dataType === 'string' ? 'left' : 'right',
                          whiteSpace: 'pre',
                        }}
                        colSpan={1}
                      >
                        {item.pdfHead}
                      </TableCell>
                    ))}
                </TableRow>
              </TableHead>
              {tableData?.length < 1 ? (
                <>
                  <TableBody>
                    <TableRow>
                      <TableCell colSpan={24}>
                        <span
                          style={{
                            display: 'flex',
                            justifyContent: 'center',
                            marginTop: '20px',
                            marginBottom: '20px',
                            color: 'red',
                            fontSize: '12px',
                          }}
                        >
                          <span>No results found. Please refine your search parameters and search again.</span>
                        </span>
                      </TableCell>
                    </TableRow>
                  </TableBody>
                </>
              ) : tableData?.length >= 1 ? (
                <TableBody
                  className="filter-data-row"
                  style={{ textAlign: 'center', fontSize: '12px', fontWeight: '700', marginLeft: '5px' }}
                >
                  {tableData?.map((item, index) => (
                    <InsideRowContent item={item} index={index} key={index} selectedFields={selectedFields} fontVal={'12px'} />
                  ))}
                </TableBody>
              ) : (
                ''
              )}
            </Table>
            <Table
              sx={{ marginRight: 2, paddingTop: '10px', marginTop: '30px', minWidth: '100%', borderTop: '1px solid #aeaeae' }}
              size="small"
              aria-label="a dense table"
            >
              <TableHead style={{ position: 'sticky', top: '0' }}>
                <TableRow>
                  <TableCell
                    style={{
                      backgroundColor: '#e5f3ff',
                      color: '#454646',
                      fontSize: '12px',
                      fontWeight: '500',
                      textAlign: 'left',
                      whiteSpace: 'nowrap',
                    }}
                    colSpan={1}
                  >
                    Payment Type
                  </TableCell>
                  <TableCell
                    style={{
                      backgroundColor: '#e5f3ff',
                      color: '#454646',
                      fontSize: '12px',
                      fontWeight: '500',
                      textAlign: 'right',
                      whiteSpace: 'nowrap',
                    }}
                    colSpan={1}
                  >
                    Item Type (Quantity)
                  </TableCell>
                  <TableCell
                    style={{
                      backgroundColor: '#e5f3ff',
                      color: '#454646',
                      fontSize: '12px',
                      fontWeight: '500',
                      textAlign: 'right',
                      whiteSpace: 'nowrap',
                    }}
                    colSpan={1}
                  >
                    Freight
                  </TableCell>
                  <TableCell
                    style={{
                      backgroundColor: '#e5f3ff',
                      color: '#454646',
                      fontSize: '12px',
                      fontWeight: '500',
                      textAlign: 'right',
                      whiteSpace: 'nowrap',
                    }}
                    colSpan={1}
                  >
                    Doc Charge
                  </TableCell>
                  <TableCell
                    style={{
                      backgroundColor: '#e5f3ff',
                      color: '#454646',
                      fontSize: '12px',
                      fontWeight: '500',
                      textAlign: 'right',
                      whiteSpace: 'nowrap',
                    }}
                    colSpan={1}
                  >
                    Cartage
                  </TableCell>
                  <TableCell
                    style={{
                      backgroundColor: '#e5f3ff',
                      color: '#454646',
                      fontSize: '12px',
                      fontWeight: '500',
                      textAlign: 'right',
                      whiteSpace: 'nowrap',
                    }}
                    colSpan={1}
                  >
                    Hamali
                  </TableCell>
                  <TableCell
                    style={{
                      backgroundColor: '#e5f3ff',
                      color: '#454646',
                      fontSize: '12px',
                      fontWeight: '500',
                      textAlign: 'right',
                      whiteSpace: 'nowrap',
                    }}
                    colSpan={1}
                  >
                    {operatorHamaliHeader}
                  </TableCell>
                  <TableCell
                    style={{
                      backgroundColor: '#e5f3ff',
                      color: '#454646',
                      fontSize: '12px',
                      fontWeight: '500',
                      textAlign: 'right',
                      whiteSpace: 'nowrap',
                    }}
                    colSpan={1}
                  >
                    Freight GST
                  </TableCell>
                  <TableCell
                    style={{
                      backgroundColor: '#e5f3ff',
                      color: '#454646',
                      fontSize: '12px',
                      fontWeight: '500',
                      textAlign: 'right',
                      whiteSpace: 'nowrap',
                    }}
                    colSpan={1}
                  >
                    Cartage GST
                  </TableCell>
                  <TableCell
                    style={{
                      backgroundColor: '#e5f3ff',
                      color: '#454646',
                      fontSize: '12px',
                      fontWeight: '500',
                      textAlign: 'right',
                      whiteSpace: 'nowrap',
                    }}
                    colSpan={1}
                  >
                    {hamOpGstHeader}
                  </TableCell>
                  <TableCell
                    style={{
                      backgroundColor: '#e5f3ff',
                      color: '#454646',
                      fontSize: '12px',
                      fontWeight: '500',
                      textAlign: 'right',
                      whiteSpace: 'nowrap',
                    }}
                    colSpan={1}
                  >
                    Valuation Charge
                  </TableCell>
                  <TableCell
                    style={{
                      backgroundColor: '#e5f3ff',
                      color: '#454646',
                      fontSize: '12px',
                      fontWeight: '500',
                      textAlign: 'right',
                      whiteSpace: 'nowrap',
                    }}
                    colSpan={1}
                  >
                    Total
                  </TableCell>
                </TableRow>
              </TableHead>
              {tableData?.length < 1 ? (
                <>
                  <TableBody>
                    <TableRow>
                      <TableCell colSpan={13}>
                        <div
                          style={{
                            display: 'flex',
                            justifyContent: 'center',
                            marginTop: '20px',
                            marginBottom: '20px',
                            color: 'red',
                            fontSize: '12px',
                          }}
                        >
                          <span>No results found. Please refine your search parameters and search again.</span>
                        </div>
                      </TableCell>
                    </TableRow>
                  </TableBody>
                </>
              ) : paymentWiseTotal?.length >= 1 ? (
                <TableBody
                  className="filter-data-row"
                  style={{ textAlign: 'center', fontSize: '12px', fontWeight: '500', marginLeft: '5px' }}
                >
                  {paymentWiseTotal?.map((item, index, itSelfArray) => (
                    <InsideRowContentSummary item={item} index={index} key={index} itSelfArray={itSelfArray} fontVal={'12px'} />
                  ))}
                </TableBody>
              ) : (
                ''
              )}
            </Table>
          </Table>
          <Table style={{ display: 'none' }} id="tables">
            <Table style={{ minWidth: '100%' }} className="table1 table-Report" size="small" aria-label="a dense table">
              {reportType?.Name === 'Cancel Dispatch' ? (
                <>
                  <TableHead style={{ display: 'none', fontWeight: 'bold' }}>
                    <TableRow>
                      <TableCell
                        className="reportTD"
                        style={{ fontWeight: 'bold', fontSize: '24px', fontWeight: '500', textAlign: 'left' }}
                        colSpan={17}
                      >
                        <h3 style={{ paddingLeft: '17px' }}>Report For: Dispatch Report -</h3>
                      </TableCell>
                      <TableCell
                        className="reportTD"
                        style={{ fontWeight: 'bold', fontSize: '24px', fontWeight: '500', textAlign: 'left' }}
                        colSpan={17}
                      >
                        <h3 style={{ paddingLeft: '17px' }}>Company Name :{loginData.strCompanyName}</h3>
                      </TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell colSpan={34}></TableCell>
                    </TableRow>
                    <TableRow style={{ color: 'white' }}>
                      <TableCell
                        className="ReportItemHead"
                        style={{
                          backgroundColor: '#bfe1ff',
                          color: '#454646',
                          fontSize: '20px',
                          fontWeight: '500',
                          textAlign: 'left',
                        }}
                        colSpan={3}
                      >
                        From Dispatch Date
                      </TableCell>
                      <TableCell
                        className="ReportItemHead"
                        style={{
                          backgroundColor: '#bfe1ff',
                          color: '#454646',
                          fontSize: '20px',
                          fontWeight: '500',
                          textAlign: 'left',
                        }}
                        colSpan={3}
                      >
                        To Dispatch Date
                      </TableCell>
                      <TableCell
                        className="ReportItemHead"
                        style={{
                          backgroundColor: '#bfe1ff',
                          color: '#454646',
                          fontSize: '20px',
                          fontWeight: '500',
                          textAlign: 'left',
                        }}
                        colSpan={3}
                      >
                        dispatch By Branch
                      </TableCell>
                      <TableCell
                        className="ReportItemHead"
                        style={{
                          backgroundColor: '#bfe1ff',
                          color: '#454646',
                          fontSize: '20px',
                          fontWeight: '500',
                          textAlign: 'left',
                        }}
                        colSpan={3}
                      >
                        Destination City
                      </TableCell>
                      <TableCell
                        className="ReportItemHead"
                        style={{
                          backgroundColor: '#bfe1ff',
                          color: '#454646',
                          fontSize: '20px',
                          fontWeight: '500',
                          textAlign: 'left',
                        }}
                        colSpan={3}
                      >
                        DestinationBranch
                      </TableCell>
                      <TableCell
                        className="ReportItemHead"
                        style={{
                          backgroundColor: '#bfe1ff',
                          color: '#454646',
                          fontSize: '20px',
                          fontWeight: '500',
                          textAlign: 'left',
                        }}
                        colSpan={3}
                      >
                        Vehicle Number
                      </TableCell>
                      <TableCell
                        className="ReportItemHead"
                        style={{
                          backgroundColor: '#bfe1ff',
                          color: '#454646',
                          fontSize: '20px',
                          fontWeight: '500',
                          textAlign: 'left',
                        }}
                        colSpan={3}
                      >
                        Payment Type
                      </TableCell>
                      <TableCell
                        className="ReportItemHead"
                        style={{
                          backgroundColor: '#bfe1ff',
                          color: '#454646',
                          fontSize: '20px',
                          fontWeight: '500',
                          textAlign: 'left',
                        }}
                        colSpan={3}
                      >
                        Report Type
                      </TableCell>
                      <TableCell
                        className="ReportItemHead"
                        style={{
                          backgroundColor: '#bfe1ff',
                          color: '#454646',
                          fontSize: '20px',
                          fontWeight: '500',
                          textAlign: 'left',
                        }}
                        colSpan={3}
                      >
                        Report View
                      </TableCell>
                      <TableCell
                        className="ReportItemHead"
                        style={{
                          backgroundColor: '#bfe1ff',
                          color: '#454646',
                          fontSize: '20px',
                          fontWeight: '500',
                          textAlign: 'left',
                        }}
                        colSpan={3}
                      >
                        Report Option
                      </TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell
                        className="reportTD"
                        style={{ fontWeight: 'bold', fontSize: '20px', fontWeight: '500', textAlign: 'left' }}
                        colSpan={3}
                      >
                        {/* {moment(new Date(item.fromDate)).format('DD-MMM-YY')} */}
                        <span>{moment(fromDate).format('DD-MMM-YY')}</span>
                      </TableCell>
                      <TableCell
                        className="reportTD"
                        style={{ fontWeight: 'bold', fontSize: '20px', fontWeight: '500', textAlign: 'left' }}
                        colSpan={3}
                      >
                        <span>{moment(toDate).format('DD-MMM-YY')}</span>
                      </TableCell>
                      <TableCell
                        className="reportTD"
                        style={{ fontWeight: 'bold', fontSize: '20px', fontWeight: '500', textAlign: 'left' }}
                        colSpan={3}
                      >
                        <span>{selFromBranch?.name || loginData?.strBranchName}</span>
                      </TableCell>
                      <TableCell
                        className="reportTD"
                        style={{ fontWeight: 'bold', fontSize: '20px', fontWeight: '500', textAlign: 'left' }}
                        colSpan={3}
                      >
                        <span>{selDestCity?.name}</span>
                      </TableCell>
                      <TableCell
                        className="reportTD"
                        style={{ fontWeight: 'bold', fontSize: '20px', fontWeight: '500', textAlign: 'left' }}
                        colSpan={3}
                      >
                        <span>{selBranch?.name}</span>
                      </TableCell>
                      <TableCell
                        className="reportTD"
                        style={{ fontWeight: 'bold', fontSize: '20px', fontWeight: '500', textAlign: 'left' }}
                        colSpan={3}
                      >
                        <span>{selVehicle?.name}</span>
                      </TableCell>
                      <TableCell
                        className="reportTD"
                        style={{ fontWeight: 'bold', fontSize: '20px', fontWeight: '500', textAlign: 'left' }}
                        colSpan={3}
                      >
                        <span>{selPaymentTpe?.name || 'All'}</span>
                      </TableCell>
                      <TableCell
                        className="reportTD"
                        style={{ fontWeight: 'bold', fontSize: '20px', fontWeight: '500', textAlign: 'left' }}
                        colSpan={3}
                      >
                        <span>{reportType?.Name}</span>
                      </TableCell>
                      <TableCell
                        className="reportTD"
                        style={{ fontWeight: 'bold', fontSize: '20px', fontWeight: '500', textAlign: 'left' }}
                        colSpan={3}
                      >
                        <span>{showSummaryReport?.Name}</span>
                      </TableCell>
                      <TableCell
                        className="reportTD"
                        style={{ fontWeight: 'bold', fontSize: '20px', fontWeight: '500', textAlign: 'left' }}
                        colSpan={3}
                      >
                        <span>{detailedFilter?.Name} </span>
                      </TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell colSpan={34}></TableCell>
                    </TableRow>
                  </TableHead>
                </>
              ) : (
                <>
                  <TableHead style={{ display: 'none', fontWeight: 'bold' }}>
                    <TableRow>
                      <TableCell
                        className="reportTD"
                        style={{ fontWeight: 'bold', fontSize: '24px', fontWeight: '500', textAlign: 'left' }}
                        colSpan={17}
                      >
                        <h3 style={{ paddingLeft: '17px' }}>Report For: Dispatch Report -</h3>
                      </TableCell>
                      <TableCell
                        className="reportTD"
                        style={{ fontWeight: 'bold', fontSize: '24px', fontWeight: '500', textAlign: 'left' }}
                        colSpan={17}
                      >
                        <h3 style={{ paddingLeft: '17px' }}>Company Name :{loginData.strCompanyName}</h3>
                      </TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell colSpan={34}></TableCell>
                    </TableRow>
                    <TableRow style={{ color: 'white' }}>
                      <TableCell
                        className="ReportItemHead"
                        style={{
                          backgroundColor: '#bfe1ff',
                          color: '#454646',
                          fontSize: '20px',
                          fontWeight: '600',
                          textAlign: 'left',
                        }}
                        colSpan={4}
                      >
                        From Dispatch Date
                      </TableCell>
                      <TableCell
                        className="ReportItemHead"
                        style={{
                          backgroundColor: '#bfe1ff',
                          color: '#454646',
                          fontSize: '20px',
                          fontWeight: '600',
                          textAlign: 'left',
                        }}
                        colSpan={3}
                      >
                        To Dispatch Date
                      </TableCell>
                      <TableCell
                        className="ReportItemHead"
                        style={{
                          backgroundColor: '#bfe1ff',
                          color: '#454646',
                          fontSize: '20px',
                          fontWeight: '600',
                          textAlign: 'left',
                        }}
                        colSpan={3}
                      >
                        dispatch By Branch
                      </TableCell>
                      <TableCell
                        className="ReportItemHead"
                        style={{
                          backgroundColor: '#bfe1ff',
                          color: '#454646',
                          fontSize: '20px',
                          fontWeight: '600',
                          textAlign: 'left',
                        }}
                        colSpan={3}
                      >
                        Destination City
                      </TableCell>
                      <TableCell
                        className="ReportItemHead"
                        style={{
                          backgroundColor: '#bfe1ff',
                          color: '#454646',
                          fontSize: '20px',
                          fontWeight: '600',
                          textAlign: 'left',
                        }}
                        colSpan={3}
                      >
                        DestinationBranch
                      </TableCell>
                      <TableCell
                        className="ReportItemHead"
                        style={{
                          backgroundColor: '#bfe1ff',
                          color: '#454646',
                          fontSize: '20px',
                          fontWeight: '600',
                          textAlign: 'left',
                        }}
                        colSpan={3}
                      >
                        Vehicle Number
                      </TableCell>
                      <TableCell
                        className="ReportItemHead"
                        style={{
                          backgroundColor: '#bfe1ff',
                          color: '#454646',
                          fontSize: '20px',
                          fontWeight: '600',
                          textAlign: 'left',
                        }}
                        colSpan={3}
                      >
                        Payment Type
                      </TableCell>
                      <TableCell
                        className="ReportItemHead"
                        style={{
                          backgroundColor: '#bfe1ff',
                          color: '#454646',
                          fontSize: '20px',
                          fontWeight: '600',
                          textAlign: 'left',
                        }}
                        colSpan={4}
                      >
                        Report Type
                      </TableCell>
                      <TableCell
                        className="ReportItemHead"
                        style={{
                          backgroundColor: '#bfe1ff',
                          color: '#454646',
                          fontSize: '20px',
                          fontWeight: '600',
                          textAlign: 'left',
                        }}
                        colSpan={4}
                      >
                        Report View
                      </TableCell>
                      <TableCell
                        className="ReportItemHead"
                        style={{
                          backgroundColor: '#bfe1ff',
                          color: '#454646',
                          fontSize: '20px',
                          fontWeight: '600',
                          textAlign: 'left',
                        }}
                        colSpan={4}
                      >
                        Report Option
                      </TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell
                        className="reportTD"
                        style={{ fontWeight: 'bold', fontSize: '20px', fontWeight: '500', textAlign: 'left' }}
                        colSpan={4}
                      >
                        <span>{moment(fromDate).format('DD-MMM-YY')}</span>
                      </TableCell>
                      <TableCell
                        className="reportTD"
                        style={{ fontWeight: 'bold', fontSize: '20px', fontWeight: '500', textAlign: 'left' }}
                        colSpan={3}
                      >
                        <span>{moment(toDate).format('DD-MMM-YY')}</span> 
                      </TableCell>
                      <TableCell
                        className="reportTD"
                        style={{ fontWeight: 'bold', fontSize: '20px', fontWeight: '500', textAlign: 'left' }}
                        colSpan={3}
                      >
                        <span>{selFromBranch?.name || loginData?.strBranchName}</span>
                      </TableCell>
                      <TableCell
                        className="reportTD"
                        style={{ fontWeight: 'bold', fontSize: '20px', fontWeight: '500', textAlign: 'left' }}
                        colSpan={3}
                      >
                        <span>{selDestCity?.name}</span>
                      </TableCell>
                      <TableCell
                        className="reportTD"
                        style={{ fontWeight: 'bold', fontSize: '20px', fontWeight: '500', textAlign: 'left' }}
                        colSpan={3}
                      >
                        <span>{selBranch?.name}</span>
                      </TableCell>
                      <TableCell
                        className="reportTD"
                        style={{ fontWeight: 'bold', fontSize: '20px', fontWeight: '500', textAlign: 'left' }}
                        colSpan={3}
                      >
                        <span>{selVehicle?.name}</span>
                      </TableCell>
                      <TableCell
                        className="reportTD"
                        style={{ fontWeight: 'bold', fontSize: '20px', fontWeight: '500', textAlign: 'left' }}
                        colSpan={3}
                      >
                        <span>{selPaymentTpe?.name || 'All'}</span>
                      </TableCell>
                      <TableCell
                        className="reportTD"
                        style={{ fontWeight: 'bold', fontSize: '20px', fontWeight: '500', textAlign: 'left' }}
                        colSpan={4}
                      >
                        <span>{reportType?.Name}</span>
                      </TableCell>
                      <TableCell
                        className="reportTD"
                        style={{ fontWeight: 'bold', fontSize: '20px', fontWeight: '500', textAlign: 'left' }}
                        colSpan={4}
                      >
                        <span>{showSummaryReport?.Name}</span>
                      </TableCell>
                      <TableCell
                        className="reportTD"
                        style={{ fontWeight: 'bold', fontSize: '20px', fontWeight: '500', textAlign: 'left' }}
                        colSpan={4}
                      >
                        <span>{detailedFilter?.Name} </span>
                      </TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell colSpan={34}></TableCell>
                    </TableRow>
                  </TableHead>
                </>
              )}
              <TableHead style={{ fontWeight: 'bold', position: 'sticky', top: '0' }}>
                <TableRow style={{ backgroundColor: '#bfe1ff', color: '#444444' }}>
                  <TableCell
                    className="reportTD"
                    style={{ fontSize: '20px', fontWeight: '700', textAlign: 'left', color: '#444444', height: '36px' }}
                    colSpan={11}
                  >
                    Dispatch By Branch: {selFromBranch?.name || loginData?.strBranchName}
                  </TableCell>
                  <TableCell
                    className="reportTD"
                    style={{ fontSize: '20px', fontWeight: '700', textAlign: 'center', color: '#444444' }}
                    colSpan={11}
                  >
                    Destination City: {selDestCity?.name}
                  </TableCell>
                  {reportType?.Name === 'Cancel Dispatch' ? (
                    <>
                      <TableCell
                        className="reportTD"
                        style={{ fontSize: '20px', fontWeight: '700', textAlign: 'right', color: '#444444' }}
                        colSpan={10}
                      >
                        Destination Branch: {selBranch?.name}
                      </TableCell>
                    </>
                  ) : (
                    <>
                      <TableCell
                        className="reportTD"
                        style={{ fontWeight: 'bold', fontSize: '20px', fontWeight: '700', textAlign: 'right', color: '#444444' }}
                        colSpan={12}
                      >
                        Destination Branch: {selBranch?.name}
                      </TableCell>
                    </>
                  )}
                </TableRow>
                <TableRow>
                  {dispatchExcelColumns?.map((val) => (
                    <TableCell
                      className="ReportItemHead"
                      style={{
                        backgroundColor: '#e5f3ff',
                        color: '#454646',
                        fontSize: '20px',
                        fontWeight: '600',
                        textAlign: 'left',
                        lineheight: '16px',
                        letterspacing: '0.24px',
                        verticalAlign: 'top',
                      }}
                      colSpan={1}
                    >
                      {val.header}
                    </TableCell>
                  ))}
                </TableRow>
              </TableHead>
              {tableData?.length < 1 ? (
                <>
                  <TableBody>
                    <TableRow>
                      <TableCell colSpan={24}>
                        <span
                          style={{
                            display: 'flex',
                            justifyContent: 'center',
                            marginTop: '20px',
                            marginBottom: '20px',
                            color: 'red',
                            fontSize: '20px',
                          }}
                        >
                          <span>No results found. Please refine your search parameters and search again.</span>
                        </span>
                      </TableCell>
                    </TableRow>
                  </TableBody>
                </>
              ) : tableData?.length >= 1 ? (
                <TableBody
                  className="filter-data-row"
                  style={{ textAlign: 'center', fontSize: '20px', fontWeight: '700', marginLeft: '5px' }}
                >
                  {tableData?.map((item, index) => (
                    <InsideRowContentForExcel item={item} index={index} key={index} selectedFields={selectedFields} fontVal={'20px'} />
                  ))}
                </TableBody>
              ) : (
                ''
              )}
            </Table>
            <Table
              style={{ marginRight: 2, paddingTop: '10px', marginTop: '30px', minWidth: '100%', borderTop: '1px solid #aeaeae' }}
              size="small"
              aria-label="a dense table"
            >
              <TableHead style={{ position: 'sticky', top: '0' }}>
                <TableRow>
                  <TableCell
                    style={{
                      backgroundColor: '#e5f3ff',
                      color: '#454646',
                      fontSize: '20px',
                      fontWeight: '600',
                      textAlign: 'left',
                      whiteSpace: 'nowrap',
                    }}
                    colSpan={1}
                  >
                    Payment Type
                  </TableCell>
                  <TableCell
                    style={{
                      backgroundColor: '#e5f3ff',
                      color: '#454646',
                      fontSize: '20px',
                      fontWeight: '600',
                      textAlign: 'right',
                      whiteSpace: 'nowrap',
                    }}
                    colSpan={1}
                  >
                    Item Type (Quantity)
                  </TableCell>
                  <TableCell
                    style={{
                      backgroundColor: '#e5f3ff',
                      color: '#454646',
                      fontSize: '20px',
                      fontWeight: '600',
                      textAlign: 'right',
                      whiteSpace: 'nowrap',
                    }}
                    colSpan={1}
                  >
                    Freight
                  </TableCell>
                  <TableCell
                    style={{
                      backgroundColor: '#e5f3ff',
                      color: '#454646',
                      fontSize: '20px',
                      fontWeight: '600',
                      textAlign: 'right',
                      whiteSpace: 'nowrap',
                    }}
                    colSpan={1}
                  >
                    Doc Charge
                  </TableCell>
                  <TableCell
                    style={{
                      backgroundColor: '#e5f3ff',
                      color: '#454646',
                      fontSize: '20px',
                      fontWeight: '600',
                      textAlign: 'right',
                      whiteSpace: 'nowrap',
                    }}
                    colSpan={1}
                  >
                    Cartage
                  </TableCell>
                  <TableCell
                    style={{
                      backgroundColor: '#e5f3ff',
                      color: '#454646',
                      fontSize: '20px',
                      fontWeight: '600',
                      textAlign: 'right',
                      whiteSpace: 'nowrap',
                    }}
                    colSpan={1}
                  >
                    Hamali
                  </TableCell>
                  <TableCell
                    style={{
                      backgroundColor: '#e5f3ff',
                      color: '#454646',
                      fontSize: '20px',
                      fontWeight: '600',
                      textAlign: 'right',
                      whiteSpace: 'nowrap',
                    }}
                    colSpan={1}
                  >
                    {operatorHamaliHeader}
                  </TableCell>
                  <TableCell
                    style={{
                      backgroundColor: '#e5f3ff',
                      color: '#454646',
                      fontSize: '20px',
                      fontWeight: '600',
                      textAlign: 'right',
                      whiteSpace: 'nowrap',
                    }}
                    colSpan={1}
                  >
                    Freight GST
                  </TableCell>
                  <TableCell
                    style={{
                      backgroundColor: '#e5f3ff',
                      color: '#454646',
                      fontSize: '20px',
                      fontWeight: '600',
                      textAlign: 'right',
                      whiteSpace: 'nowrap',
                    }}
                    colSpan={1}
                  >
                    Cartage GST
                  </TableCell>
                  <TableCell
                    style={{
                      backgroundColor: '#e5f3ff',
                      color: '#454646',
                      fontSize: '20px',
                      fontWeight: '600',
                      textAlign: 'right',
                      whiteSpace: 'nowrap',
                    }}
                    colSpan={1}
                  >
                    {hamOpGstHeader}
                  </TableCell>
                  <TableCell
                    style={{
                      backgroundColor: '#e5f3ff',
                      color: '#454646',
                      fontSize: '20px',
                      fontWeight: '600',
                      textAlign: 'right',
                      whiteSpace: 'nowrap',
                    }}
                    colSpan={1}
                  >
                    Valuation Charge
                  </TableCell>
                  <TableCell
                    style={{
                      backgroundColor: '#e5f3ff',
                      color: '#454646',
                      fontSize: '20px',
                      fontWeight: '600',
                      textAlign: 'right',
                      whiteSpace: 'nowrap',
                    }}
                    colSpan={1}
                  >
                    Total
                  </TableCell>
                </TableRow>
              </TableHead>
              {tableData?.length < 1 ? (
                <>
                  <TableBody>
                    <TableRow>
                      <TableCell colSpan={13}>
                        <div
                          style={{
                            display: 'flex',
                            justifyContent: 'center',
                            marginTop: '20px',
                            marginBottom: '20px',
                            color: 'red',
                            fontSize: '20px',
                          }}
                        >
                          <span>No results found. Please refine your search parameters and search again.</span>
                        </div>
                      </TableCell>
                    </TableRow>
                  </TableBody>
                </>
              ) : paymentWiseTotal?.length >= 1 ? (
                <TableBody
                  className="filter-data-row"
                  style={{ textAlign: 'center', fontSize: '20px', fontWeight: '500', marginLeft: '5px' }}
                >
                  {paymentWiseTotal?.map((item, index, itSelfArray) => (
                    <InsideRowContentSummary item={item} index={index} key={index} itSelfArray={itSelfArray} fontVal={'20px'} />
                  ))}
                </TableBody>
              ) : (
                ''
              )}
            </Table>
          </Table>
        </TableContainer>
      </Stack>
    </>
  )
}

export default DispatchMiddSection1
